module.exports = __webpack_public_path__ + "assets/icon-next-blue.09161c3a.svg";